import React from 'react';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const features = [
    {
      icon: 'fas fa-award',
      title: 'Quality Assurance',
      description: 'We maintain the highest standards in powder coating with rigorous quality control processes and certified finishes that meet industry standards.'
    },
    {
      icon: 'fas fa-clock',
      title: 'Fast Turnaround',
      description: 'Our efficient processes and experienced team ensure quick turnaround times without compromising on quality or finish durability.'
    },
    {
      icon: 'fas fa-tools',
      title: 'Advanced Equipment',
      description: 'State-of-the-art powder coating equipment and facilities ensure consistent, high-quality finishes for all types of projects.'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Us</h2>
            <p>
              At Glitter Metal coating and Fabrication L.L.C, we are Driven with a fresh perspective on powder coating and Fabrication by a commitment to quality, precision, and customer satisfaction. Our team is passionate about providing exceptional finishes for both industrial and commercial clients. We believe in the power of innovation and strive to learn and grow with every project, ensuring we deliver outstanding results tailored to your needs. We work with the latest equipment and continuously refine our techniques to ensure that your products receive the best possible care and finish.
            </p>
            
            <p>
              We are backed by a hardworking team that is passionate about delivering high-quality results and building long-term customer relationships. We combine modern tools with a customer-first mindset to offer dependable and cost-effective solutions. As we continue to grow, our aim is simple: to become a trusted name known for consistency, honesty, and workmanship.
            </p>

            <div className="mission-vision">
              <div className="mission">
                <h3><i className="fas fa-bullseye"></i> Our Mission</h3>
                <p>Our mission is to provide top-notch powder coating and fabrication services that not only protect but also enhance the aesthetic appeal of our clients' products. As a new player in the industry, we're committed to constantly evolving, refining our skills, and delivering results that exceed expectations. With a strong focus on quality, integrity, and customer satisfaction, we aim to build lasting partnerships that foster trust and success.</p>
              </div>
              
              <div className="vision">
                <h3><i className="fas fa-eye"></i> Our Vision</h3>
                <p>Our vision is to become a trusted name in the powder coating and fabrication industry by consistently delivering high-quality, innovative solutions. We strive to grow through expertise, technology, and a relentless commitment to meeting our customers needs. Our goal is to build a reputation for excellence, ensuring that we're recognized as the reliable choice for businesses seeking durability, craftsmanship, and value.</p>
              </div>
            </div>
            
            <div className="about-features" ref={ref}>
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className={`feature ${inView ? 'fade-in-up' : ''}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <h3>
                    <i className={feature.icon}></i> {feature.title}
                  </h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 